import _defineProperty from '@babel/runtime-corejs2/helpers/defineProperty';
import { forwardRef, useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import Icon from '@locus-labs/mol-desktop-icon';
import styledSystemPropTypes from '@styled-system/prop-types';
import Ripples from 'react-touch-ripple';
import LoadingIndicator from '@locus-labs/mol-desktop-loading-indicator';
import { compose, background, border, color, layout, position, shadow, space, typography } from 'styled-system';
import { theme, ifProp, prop } from 'styled-tools';
import { jsx, Fragment } from 'react/jsx-runtime';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const StyledMapNavButton = styled('button').withConfig({
  displayName: "map-nav-button__StyledMapNavButton",
  componentId: "sc-1nz48ot-0"
})(["background-color:", ";opacity:0.85;width:30px;height:30px;border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;border-radius:", ";&:hover{opacity:1;}&:active{outline:none;border:none;}&:focus{outline:none;border:none;}&:focus-visible{outline:none;border:none;}", ""], theme('colors.mapNavBackground'), theme('radii.lg'), compose(background, border, color, layout, position, shadow, space, typography));

/* this component has to be adjusted when the button is stacked. This is about looking for changed to the dropshadow or radius sent to the map nav button via styled components and overiding the these styles (and theme) with props sent to the map nav button */
const StyledMapNavButtonDropShadow = styled.div.attrs(props => ({
  boxShadow: props.children.props.children.props.boxShadow,
  borderRadius: props.children.props.children.props.borderRadius,
  borderTopLeftRadius: props.children.props.children.props.borderTopLeftRadius,
  borderTopRightRadius: props.children.props.children.props.borderTopRightRadius,
  borderBottomLeftRadius: props.children.props.children.props.borderBottomLeftRadius,
  borderBottomRightRadius: props.children.props.children.props.borderBottomRightRadius
})).withConfig({
  displayName: "map-nav-button__StyledMapNavButtonDropShadow",
  componentId: "sc-1nz48ot-1"
})(["box-shadow:", ";width:30px;height:30px;background-color:transparent;", ";", ";", ";", ";", ";&:focus-visible{outline:none;border:none;}&:has(:focus-visible){outline:2px solid darkorange;outline-offset:1px;}"], ifProp('boxShadow', prop('boxShadow'), theme('shadows.md')), ifProp('borderRadius', css(["border-radius:", ";"], prop('borderRadius')), css(["border-radius:", ";"], theme('radii.lg'))), ifProp('borderTopLeftRadius', css(["border-top-left-radius:", ";"], prop('borderTopLeftRadius'))), ifProp('borderTopRightRadius', css(["border-top-right-radius:", ";"], prop('borderTopRightRadius'))), ifProp('borderBottomLeftRadius', css(["border-bottom-left-radius:", ";"], prop('borderBottomLeftRadius'))), ifProp('borderBottomRightRadius', css(["border-bottom-right-radius:", ";"], prop('borderBottomRightRadius'))));
const MapNavButton = /*#__PURE__*/forwardRef((props, ref) => {
  const themeContext = useContext(ThemeContext);
  return /*#__PURE__*/jsx(Fragment, {
    children: props.loader ? /*#__PURE__*/jsx(StyledMapNavButton, _objectSpread(_objectSpread({
      boxShadow: "md",
      ref: ref,
      "aria-label": props.ariaLabel || typeof props.children === 'string' && props.children || ''
    }, props), {}, {
      children: /*#__PURE__*/jsx(LoadingIndicator, {
        spinnerColor: "white",
        size: "xxsm"
      })
    })) : /*#__PURE__*/jsx(StyledMapNavButtonDropShadow, {
      children: /*#__PURE__*/jsx(Ripples, {
        center: props.isRippleClickEffectCentered ? true : false,
        color: "#C0C0C0",
        children: /*#__PURE__*/jsx(StyledMapNavButton, _objectSpread(_objectSpread({
          ref: ref,
          "aria-label": props.ariaLabel || typeof props.children === 'string' && props.children || ''
        }, props), {}, {
          children: /*#__PURE__*/jsx(Icon, {
            name: props.iconName,
            iconSize: "sm",
            degreesOfIconRotation: props.degreesOfIconRotation,
            color: themeContext.colors.mapNavText
          })
        }))
      })
    })
  });
});
MapNavButton.displayName = 'Map Nav Button';
MapNavButton.defaultProps = {
  'data-cy': 'MapNavButton',
  // component name
  loader: false
};
MapNavButton.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styledSystemPropTypes.space), styledSystemPropTypes.color), styledSystemPropTypes.background), styledSystemPropTypes.border), styledSystemPropTypes.layout), styledSystemPropTypes.position), styledSystemPropTypes.shadow), styledSystemPropTypes.typography), {}, {
  as: PropTypes.string,
  forwardAs: PropTypes.string,
  iconName: PropTypes.string,
  loader: PropTypes.bool,
  isRippleClickEffectCentered: PropTypes.string,
  degreesOfIconRotation: PropTypes.number,
  ariaLabel: PropTypes.string
});

export default MapNavButton;
